// source: imports/options/amplitude_event_name.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol(
    'proto.com.chegg.rio.metadata.amplitude.AmplitudeEventName', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.metadata.amplitude.AmplitudeEventName = {
  UNKNOWN_AMPLITUDEEVENTNAME: 0,
  NEW_USER_SESSION_EVENT: 1,
  MARKETING_CHANNEL_ATTRIBUTION_EVENT: 2,
  ECOM_ORDER_PLACED_EVENT: 3,
  ECOM_SUBSCRIPTION_RENEWED_EVENT: 4,
  ECOM_PAYMENT_AUTHORIZED_EVENT: 5,
  BOT_CRAWL_EVENT: 6,
  PURCHASE_EVENT: 7,
  VIEW_TBS_CONTENT: 8,
  VIEW_QNA_CONTENT: 9,
  VIEW_HOME_PAGE: 10,
  VIEW_POST_A_QUESTION: 11,
  VIEW_UVERSITY_CONTENT: 12,
  VIEW_WRITING_CENTER_CONTENT: 13,
  VIEW_SEARCH_CONTENT: 14,
  VIEW_PREP_CONTENT: 15,
  VIEW_CAPP_CONTENT: 16,
  VIEW_VIDEO_CONTENT: 17,
  VIEW_CHEGGMATE_CONTENT: 18,
  INTERACT_CHEGGMATE_CONTENT: 19,
  NOTIFICATION_AUTH_CONTENT: 20,
  ECOM_ORDER_PLACED: 21,
  INTERACT_AUTH_CONTENT: 22,
  VIEW_AUTH_CONTENT: 23,
  ECOM_SUBSCRIPTION_PAUSE_REQUESTED: 24,
  ECOM_SUBSCRIPTION_PAUSED: 25,
  ECOM_SUBSCRIPTION_PAUSE_REQUEST_UNDO: 26,
  ECOM_SUBSCRIPTION_RENEWED: 27,
  ECOM_SUBSCRIPTION_RESUMED: 28,
  ECOM_SUBSCRIPTION_RESUME_REQUESTED: 29,
  ECOM_ORDER_CANCEL_REQUESTED: 30,
  ECOM_ORDER_CANCEL_REQUEST_UNDO: 31,
  ECOM_SWAP_REQUEST: 32,
  ECOM_SWAP_COMPLETE: 33,
  ECOM_ORDER_CANCELLED: 34,
  ECOM_SWAP_REFUND: 35,
  ECOM_PAYMENT_AUTHORIZED: 36,
  ECOM_PAYMENT_DECLINED: 37,
  ECOM_PAYMENT_SUCCESS: 38,
  INTERACT_NAV_CONTENT: 39,
  COMPONENT_CONVERSION_CONTENT: 40,
  INTERACT_CONVERSION_CONTENT: 41,
  VIEW_MLP_CONTENT: 42,
  COMPONENT_NAV_BAR: 43,
  INTERACT_HONORSHIELD_CONTENT: 44,
  INTERACT_RATING_CONTENT: 45,
  TIME_ON_PAGE: 46,
  COMPONENT_QNA_CONTENT: 47,
  COMPONENT_POST_A_QUESTION: 48,
  INTERACT_POST_A_QUESTION: 49,
  COMPONENT_UNIFIED_INPUT: 50,
  INTERACTION_UNIFIED_INPUT: 51,
  SUCCESS_UNIFIED_INPUT: 52,
  COMPONENT_ONBOARDING_CONTENT: 53,
  INTERACT_ONBOARDING_CONTENT: 54,
  SUCCESS_ONBOARDING_CONTENT: 55,
  QNA_PROCESSING_EVENT: 56,
  INTERACT_QNA_CONTENT: 57,
  NOTIFICATION_POST_A_QUESTION: 58,
  SUCCESS_POST_A_QUESTION: 59,
  COMPONENT_RATING_CONTENT: 60,
  COMPONENT_SEARCH_CONTENT: 61,
  INTERACT_SEARCH_CONTENT: 62,
  ECOM_SUBSCRIPTION_METADATA_CHANGE: 63,
  NOTIFICATION_UNIFIED_INPUT: 64,
  ECOM_INVOICE_CREATED: 65,
  ECOM_SUBSCRIPTION_CREATED: 66,
  COMPONENT_ACQUISITION_CONTENT: 67,
  INTERACT_ACQUISITION_CONTENT: 68,
  COMPONENT_AUTH_CONTENT: 69,
  USER_ACCOUNT_ACTION: 70,
  VIEW_CONVERSION_CONTENT: 71,
  PARTNER_ACTIVATION: 72,
  LLM_USAGE: 73,
  UPDATE_MESSAGE_METADATA: 74,
  CREATE_MESSAGE: 75,
  USER_ACCOUNT_SHARING: 76,
  ECOM_PAYMENT_RETRY_ATTEMPT: 77,
  ECOM_SUBSCRIPTION_CANCELLED: 78,
  ECOM_CREDIT_MEMO_CREATED: 79,
  ECOM_SUBSCRIPTION_CANCEL_REQUESTED: 80,
  ECOM_SUBSCRIPTION_CANCEL_REQUEST_UNDO: 81,
  ECOM_REFUND_SUCCESS: 82,
  ECOM_REFUND_DECLINED: 83,
  ECOM_COURTESY_REFUND_REQUESTED: 84,
  QNA_TRANSLATION: 85,
  NOTIFICATION_SIGN_IN_SUCCESS: 86,
  NOTIFICATION_SIGN_IN_START: 87,
  NOTIFICATION_SIGN_UP_START: 88,
  NOTIFICATION_SIGN_UP_SUCCESS: 89,
  MODEL_ABUSE_DETECTION: 90,
  MLMODEL_USAGE: 91,
  COMPONENT_WRITING_CENTER_CONTENT: 92,
  SUCCESS_WRITING_CENTER_CONTENT: 93,
  INTERACTION_WRITING_CENTER_CONTENT: 94,
  ANNOTATION_LABELLED_EVENT: 95,
  EXPERT_FRAUD_STATE_CHANGE: 96,
  EXPERT_ANSWER_CREATE_TRACKING_EVENT: 97,
  EXPERT_TRAINING_FILE_PROCESSING_EVENT: 98,
  EXPERT_TRAINING_USER_STATUS_EVENT: 99,
  EXPERT_TRAINING_COURSE_STATUS_EVENT: 100,
  FACE_RECOGNITION_EVENT: 101,
  DISCORD_ASK_CHEGG: 102,
  POWERNOTES: 103,
  DISCORD_QUIZ: 104,
  VIEW_FOCUSED_STUDY_CONTENT: 105,
  EXPERT_AUTH0_EVENT: 106,
  AUTO_RULES_EVALUATION_RESULT: 107,
  DISCORD_APP_INSTALL: 108
};

goog.object.extend(exports, proto.com.chegg.rio.metadata.amplitude);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/options/amplitude_event_name_pb.js
// module id = 1447
// module chunks = 11